import intl from './IntlTelInput'

export default intl


// WEBPACK FOOTER //
// app/javascript/components/fields/IntlTelInput/index.js